import { useState, useEffect, useRef } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { dateBeautify, dateBeautifyAsHrs } from "../../helpers/utils";
import {
  usePriorityList,
  updatePriorityOrderList,
  useProjectsList,
  usePriorityTotal,
  useEmployeeList,
  TaskOrderTotalType,
} from "./api";
import { TaskList } from "../../components/TaskList";
import { MultiSelect } from "primereact/multiselect";
import { useTaskStatus, AssigneeType, Assignee } from "../Task/api";
import { TaskType, TaskAssignees } from "../../components/TaskList";
import { Dropdown } from "primereact/dropdown";
import { hasPermission } from "../../helpers/common";
import { getPermissionsList } from "../../helpers/getPermission";
import { Toast } from "primereact/toast";
import DefaultImage from "../../profile_images/DefaultImage";

const ArrangeTaskPriority = ({
  taskList,
  tasks,
  setTasks,
}: {
  taskList: any;
  tasks: any;
  setTasks: any;
}) => {
  useEffect(() => {
    setTasks(taskList);
  }, [taskList]);

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const tasksList = Array.from(tasks);
    const [reorderItem] = tasksList.splice(result.source.index, 1);
    tasksList.splice(result.destination.index, 0, reorderItem);
    setTasks(tasksList);
  };

  return (
    <>
      <div className="tsk-lists-wrap">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="taskPriority">
            {(provided) => (
              <div
                className="tsk-lists drg pjt tsk assig sts dd"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <div className="dtls-mn-sec">
                  <div className="d-flex list-headings">
                    <div className="d-flex drag-indicator"></div>
                    <p className="d-flex pjt-wid">Project</p>
                    <p className="d-flex tsk-wid">task</p>
                    <p className="d-flex assig-wid">assignees</p>
                    <p className="d-flex sts-wid">status</p>
                    <p className="d-flex dd-wid">due date</p>
                  </div>
                  {tasks?.map((task: any, index: number) => (
                    <Draggable
                      key={task._id}
                      index={index}
                      draggableId={task._id}
                    >
                      {(provided) => (
                        <div
                          className="lst-tsk-main"
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div className="d-flex lst-tsk-nm">
                            <div className="d-flex drag-indicator active">
                              <span className="material-icons-round">
                                drag_indicator
                              </span>
                            </div>
                            <div className="d-flex pjt-wid">
                              <div className="d-flex flex-align-center icon-title-sm">
                                <img
                                  src="../assets/image/fiber_manual_record.svg"
                                  alt=""
                                  className="img-fluid"
                                />
                                <span> {task.projectId?.project_name} </span>
                              </div>
                            </div>
                            <div className="d-flex tsk-wid tsk-box">
                              <div className="d-flex list-nm-ryt">
                                <div className="d-flex tsk-icon">
                                  <span className="material-icons-round">
                                    bolt
                                  </span>
                                </div>
                                <div className="d-flex tsk-id">
                                  <p>{task.taskId}</p>
                                </div>
                                <div className="d-flex tsk-nm">
                                  <p>{task.name}</p>
                                </div>
                              </div>
                              <div className="d-flex tsk-exp-more">
                                <span className="material-icons-round">
                                  expand_less
                                </span>
                              </div>
                            </div>
                            <div className="d-flex assig-wid assig-box">
                              <TaskAssignees assignees={task?.members} />
                            </div>
                            <div className="d-flex sts-wid box">
                              <img
                                src="../assets/image/in-progress.svg"
                                alt=""
                              />
                              <p className="status-nm">{task?.status?.name}</p>
                            </div>
                            <div className="d-flex dd-wid box">
                              <p className="dd">
                                {dateBeautify(task?.due_date)}
                              </p>
                            </div>
                          </div>

                          {/* sub task */}

                          {task?.subTasks?.map(
                            (subTask: any, index: number) => {
                              return (
                                <div key={index} className="sub-tasks">
                                  <div className="line-exp">
                                    <div className="d-flex">
                                      <div className="d-flex drag-indicator"></div>
                                      <p className="d-flex pjt-wid"> </p>
                                      <div className="d-flex mt-five sub-tsk-ml lst-tsk-nm">
                                        <div className="d-flex sub-tsk-wid tsk-box">
                                          <div className="d-flex list-nm-ryt">
                                            <div className="d-flex sub-tsk-icon">
                                              <span className="material-icons-round in-review">
                                                subdirectory_arrow_right
                                              </span>
                                            </div>
                                            <div className="d-flex tsk-id">
                                              <p>{subTask?._id}</p>
                                            </div>
                                            <div className="d-flex tsk-nm">
                                              <p>{subTask.name}</p>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-flex sub-assig-wid assig-wid assig-box">
                                          <div className="d-flex assig-pic">
                                            {/* <img src={subTask.assignee?.profilepic} alt="" /> */}
                                            <DefaultImage
                                              src={subTask.assignee?.profilepic}
                                              alt=""
                                              className=""
                                              letter={subTask.assignee?.name[0]}
                                            />
                                          </div>
                                        </div>
                                        <div className="d-flex sub-sts-wid sts-wid box">
                                          <img
                                            src="../assets/image/in-review.svg"
                                            alt=""
                                          />
                                          <p className="status-nm">
                                            {subTask.status.name}
                                          </p>
                                        </div>
                                        <div className="d-flex sub-dd-wid dd-wid box">
                                          <p className="dd">
                                            {dateBeautify(subTask?.due_date)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
};

const selectedCountryTemplate: React.FC = (option: any, props: any) => {
  if (option) {
    return (
      <>
        <span
          style={{ backgroundColor: option.color }}
          className="material-icons-outlined"
        >
          filter_alt
        </span>
        <span>{option.name}</span>
      </>
    );
  }

  return (
    <>
      <span className="material-icons-outlined">filter_alt</span>
      <span>{props.placeholder}</span>
    </>
  );
};

const PriorityHeader = ({
  assignees,
  priorityTotal,
  permissions,
  selectEmployee,
  editPriorityList,
  setSelectedEmployee,
  setEditPriorityList,
  selectedProject,
  setSelectedProject,
  selectedStatus,
  setSelectedStatus,
  role,
}: {
  assignees: AssigneeType[];
  priorityTotal: TaskOrderTotalType | undefined;
  editPriorityList: boolean;
  selectEmployee: string;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  setEditPriorityList: React.Dispatch<React.SetStateAction<boolean>>;
  selectedProject: string;
  setSelectedProject: React.Dispatch<React.SetStateAction<string>>;
  selectedStatus: string;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>;
  permissions: any;
  role: string;
}) => {
  const { taskStatus } = useTaskStatus();
  const { userProjects } = useProjectsList(selectEmployee);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [selectedSort, setSelectedSort] = useState("Default");
  let statusList;

  if (taskStatus) {
    statusList = [ ...taskStatus];
  }
  const priorityData = [
    { label: "Created Date", value: "Default" },
    { label: "End Date (N to O)", value: "DLH" },
    { label: "End Date (O to N)", value: "DHL" },
    { label: "Priority (H to L)", value: "PHL" },
    { label: "Priority (L to H)", value: "PLH" },
  ];
  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* <img src={option.profilepic} /> */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* <img src={option.profilepic} className=""/> */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  return (
    <div className="task-top-table-separate team-theme">
      <div className="mn-dtls-vw container">
        <div className="d-flex dtls-top-sec">
          <div className="d-flex task-nm-dtls" style={{ width: "auto" }}>
            <div className="d-flex flex-align-item-center">
              <span className="material-icons-outlined">
                format_list_numbered
              </span>
              <p>Priority List</p>
            </div>
            {(role == "Leader" || role == "Manager") ? (
              <div className="d-flex priority-edit-action">
                <div className="d-flex drpdwn-slct status-slct">
                  <Dropdown
                    name="assignees"
                    optionLabel="name"
                    optionValue="_id"
                    value={selectEmployee}
                    onChange={(e) => setSelectedEmployee(e.target.value)}
                    options={assignees}
                    itemTemplate={assgineesOptionTemplate}
                    valueTemplate={selectedAssgineesTemplate}
                    disabled={editPriorityList ? true : false}
                    placeholder="Select"
                  />
                </div>

                {hasPermission(permissions, ["taskpriority:write"]) &&
                  (editPriorityList ? (
                    ""
                  ) : (
                    <div className="btm-actions">
                      <button
                        className="d-flex outline-button priority-btn btn-sm"
                        type="button"
                        onClick={() => setEditPriorityList(true)}
                      >
                        <span className="material-icons-outlined">edit</span>
                        <p>Set Priorities</p>
                      </button>
                    </div>
                  ))}
              </div>
            ) : null}

            {
              !editPriorityList && (
                <>
 <div className="d-flex drpdwn-slct status-slct">
                <MultiSelect
                  value={selectedStatuses}
                  options={statusList}
                  onChange={(e) => {
                    setSelectedStatuses(e.value);
                    setSelectedStatus(e.value.length > 0 ? e.value.join(", ") : "All"); 
                  }}
                  optionLabel="name"
                  optionValue="_id"
                  placeholder="Select Status"
                  maxSelectedLabels={3}
  
                />
              </div>
                  {/* <div className="d-flex drpdwn-slct">
              <span className="material-icons-round">sort</span>
              <Dropdown
                value={selectedSort}
                onChange={(e) => setSelectedSort(e.value)}
                options={priorityData}
                placeholder="Select"
              />
            </div> */}
                </>
               
  
              )
            }

           

          
          </div>
          <div className="d-flex task-dp-dtls">
            <div className="d-flex tsk-counts">
              <div className="d-flex details-count-action">
                <div className="d-flex">
                  <div className="d-flex">
                    <p>{priorityTotal?.totalProjects} Projects</p>
                  </div>
                  <div className="d-flex">
                    <p className="lab-dot"></p>
                    <p>{priorityTotal?.totalTasks} Tasks</p>
                  </div>
                  <div className="d-flex">
                    <p className="lab-dot"></p>
                    <p>{priorityTotal?.totalSubTasks} Sub Tasks</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PriorityTaskList = ({
  myToast,
  editPriorityList,
  selectEmployee,
  priorityTotal,
  setEditPriorityList,
  selectedStatus,
  selectedProject,
  setSelectedProject,
  setSelectedStatus,
  selectedSort,setSelectedSort
}: {
  myToast: any;
  editPriorityList: boolean;
  selectEmployee: string | undefined;
  setEditPriorityList: React.Dispatch<React.SetStateAction<boolean>>;
  priorityTotal: TaskOrderTotalType | undefined;
  selectedStatus: string;
  selectedProject: string;
  setSelectedProject: React.Dispatch<React.SetStateAction<string>>;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>;
  selectedSort:string;
  setSelectedSort:React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [tasks, setTasks] = useState([]);
  const {
    priorityList,
    isPriorityLoading,
    priorityListMutate,
    isPriorityError,
  } = usePriorityList(selectEmployee, selectedProject, selectedStatus);

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };
  return (
    <>
      {editPriorityList && priorityList && priorityList.length > 0 ? (
        <ArrangeTaskPriority
          tasks={tasks}
          setTasks={setTasks}
          taskList={priorityList}
        />
      ) : (
        <TaskList
          taskList={priorityList}
          isPriorityLoading={isPriorityLoading}
          isPriorityError={isPriorityError}
        />
      )}
      {priorityList && priorityList.length > 0 ? (
        <PriorityFooter
          showToast={showToast}
          editPriorityList={editPriorityList}
          selectEmployee={selectEmployee}
          refreshOrderList={priorityListMutate}
          priorityTotal={priorityTotal}
          tasks={tasks}
          setEditPriorityList={setEditPriorityList}
        />
      ) : (
        ""
      )}
    </>
  );
};

const updatePriorityList = async (
  showToast: any,
  employeeId: string | undefined,
  taskpriorityId: TaskOrderTotalType | undefined,
  tasks: any,
  refreshOrderList: any,
  setEditPriorityList: React.Dispatch<React.SetStateAction<boolean>>
) => {
  let taskIds = tasks.map((item: { _id: any }) => {
    return item._id;
  });
  if (taskIds && employeeId && taskpriorityId) {
    let result = await updatePriorityOrderList(employeeId, taskpriorityId._id, {
      taskList: taskIds,
    });
    if (result.status === 200) {
      showToast(
        "success",
        "Success Message",
        "Task list was updated successfully."
      );
    }
  }
  refreshOrderList();
  setEditPriorityList(false);
};

const PriorityFooter = ({
  showToast,
  tasks,
  selectEmployee,
  editPriorityList,
  refreshOrderList,
  priorityTotal,
  setEditPriorityList,
}: {
  showToast: any;
  priorityTotal: TaskOrderTotalType | undefined;
  editPriorityList: boolean;
  refreshOrderList: any;
  selectEmployee: string | undefined;
  tasks: any;
  setEditPriorityList: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  // State to track whether saving,revert is in progress
  const [isSaving, setIsSaving] = useState(false);
  const [isReverting, setIsReverting] = useState(false);

  // Handle save logic
  const handleSaveChanges = async () => {
    // Disable button when clicked
    setIsSaving(true);

    // Trigger the save action
    await updatePriorityList(
      showToast,
      selectEmployee,
      priorityTotal,
      tasks,
      setEditPriorityList,
      refreshOrderList
    );

    // Optionally, re-enable the button if needed (e.g., after success/failure)
    setIsSaving(false);
  };

  // Handle revert logic
  const handleRevertChanges = () => {
    setIsReverting(true); // Disable revert button
    setEditPriorityList(false);
    setIsReverting(false); // Re-enable revert button if needed (optional)
  };

  return (
    <div className="dtls-bottom-sec">
      <div className="mn-dtls-vw container">
        <div className="dtls-bottom-sec-last-update-action d-flex">
          <div className="user-img-details-last-updated d-flex">
            <div className="user-image-block-sm">
              <img
                src={priorityTotal?.updatedBy.profilepic}
                alt=""
                className="img-fluid"
              />
              <DefaultImage
                src={priorityTotal?.updatedBy.profilepic}
                alt=""
                className="img-fluid"
                letter={priorityTotal?.updatedBy?.name[0]}
              />
            </div>
            <div className="user-name-last-update">
              {priorityTotal?.updatedBy?.name}{" "}
              <span>
                {" "}
                Last updated • {dateBeautifyAsHrs(
                  priorityTotal?.updatedOn
                )}{" "}
              </span>
            </div>
          </div>
          {editPriorityList ? (
            <div className="btm-actions">
              <button
                type="button"
                className="btn cancel"
                data-bs-dismiss="modal"
                onClick={handleRevertChanges}
                disabled={isReverting} // Disable the revert button when clicked
              >
                {isReverting ? "Reverting..." : "Revert"}
              </button>
              <button
                type="button"
                className="btn save"
                onClick={handleSaveChanges}
                disabled={isSaving} // Disable button if saving is in progress
              >
                {isSaving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

function Priority() {
  const [selectedStatus, setSelectedStatus] = useState<string>("All");
  const [selectedProject, setSelectedProject] = useState<string>("All");
const [selectedSort,setSelectedSort]=useState<string>("All");
  const [editPriorityList, setEditPriorityList] = useState(false);

  const { assignees } = useEmployeeList();

  const [permissions, setPermissions] = useState<string[]>([]);

  const [role, setRole] = useState<string>("");
  useEffect(() => {
    _getPermissions();
  }, []);
  const [selectEmployee, setSelectedEmployee] = useState<any>();
  const _getPermissions = async () => {
    let token = await getPermissionsList();
    setPermissions(token?.permissions);
    setSelectedEmployee(token?.login_user?._id);
    setRole(token?.login_user?.role);
  };
  const myToast = useRef(null);
  const encodedStatus = Array.isArray(selectedStatus)
  ? encodeURIComponent(selectedStatus.join(','))
  : encodeURIComponent(selectedStatus || '');

  const { priorityTotal,refetch } = usePriorityTotal(selectEmployee,encodedStatus);

useEffect(() => {
  refetch();
}, [selectEmployee, selectedStatus]); 

  const selectedCountryTemplate: React.FC = (option: any, props: any) => {
    if (option) {
      return (
        <>
          <span
            style={{ backgroundColor: option.color }}
            className="material-icons-outlined"
          >
            filter_alt
          </span>
          <span>{option.name}</span>
        </>
      );
    }

    return (
      <>
        <span className="material-icons-outlined">filter_alt</span>
        <span>{props.placeholder}</span>
      </>
    );
  };

  return (
    <>
      <>
        <div
          className={`priority-task-block task-top-table-separate task-all-project-length
             task-all-projects task-project-cell-active ${editPriorityList ? "task-drag-cell-active" : ""
            }`}
        >
          <PriorityHeader
            assignees={assignees}
            permissions={permissions}
            priorityTotal={priorityTotal}
            selectEmployee={selectEmployee}
            setSelectedEmployee={setSelectedEmployee}
            setEditPriorityList={setEditPriorityList}
            editPriorityList={editPriorityList}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            role={role}
          />
          <PriorityTaskList
            myToast={myToast}
            editPriorityList={editPriorityList}
            selectEmployee={selectEmployee}
            selectedStatus={selectedStatus}
            selectedProject={selectedProject}
            priorityTotal={priorityTotal}
            setEditPriorityList={setEditPriorityList}
            setSelectedProject={setSelectedProject}
            setSelectedStatus={setSelectedStatus}
            selectedSort={selectedSort}
            setSelectedSort={setSelectedSort}
          />
        </div>
        <Toast ref={myToast} />
      </>
    </>
  );
}

export default Priority;
